import type { ComponentProps } from 'react';

import type { VariantProps } from 'tailwind-variants';

import { separatorStyles } from './styles/separator.style';

type SeparatorProps = ComponentProps<'hr'> &
  VariantProps<typeof separatorStyles>;

export function Separator({
  className,
  orientation,
  variant,
  ...props
}: SeparatorProps) {
  return (
    <hr
      className={separatorStyles({ className, variant, orientation })}
      {...props}
    />
  );
}
